// extracted by mini-css-extract-plugin
var _1 = "Welcome_headerImage__6HgKH";
var _2 = "Welcome_intro__f0EsU";
var _3 = "768px";
var _4 = "'../../shared.module.css'";
var _5 = "Welcome_title__pcyIl";
var _6 = "Welcome_welcomeContainer__gReXP";
export { _1 as "headerImage", _2 as "intro", _3 as "md", _4 as "shared", _5 as "title", _6 as "welcomeContainer" }
